import { connect } from 'react-redux';
import {
    showPortfolioLoader,
    onPortfolioDashboard,
} from 'actions/portfolio';
import Component from './component';

const mapStateToProps = ({ portfolios, settings }) => {
    const { width } = settings;
    const {
        loader,
        alertMessage,
        showMessage,
        selectedPortfolio,
        selectedDashboardPortfolio,
    } = portfolios;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        selectedPortfolio,
        selectedDashboardPortfolio,
    };
};
export default connect(mapStateToProps,
    {
        showPortfolioLoader,
        onPortfolioDashboard,
    })(Component);


// WEBPACK FOOTER //
// ./components/Agile/portfolioDashboard/Container.js